module.exports = __webpack_public_path__ + "img/Greece.74479b6b.svg";